import { GradeLevel } from '../models/grade-level';

export const gradeLevelToNumber = (gradeLevel: GradeLevel) => {
  switch (gradeLevel) {
    case GradeLevel.TRANSITIONAL_KINDERGARTEN:
      return 'tk';
    case GradeLevel.KINDERGARTEN:
      return 'k';
    case GradeLevel.FIRST:
      return 1;
    case GradeLevel.SECOND:
      return 2;
    case GradeLevel.THIRD:
      return 3;
    case GradeLevel.FOURTH:
      return 4;
    case GradeLevel.FIFTH:
      return 5;
    case GradeLevel.SIXTH:
      return 6;
  }
};
